import { BaseEntity } from 'yt-ng-framework';
export class Dokument extends BaseEntity{
    constructor(){
        super();
    }

    PodVrstaDokumentaStavkaID: number = null;
    BrojDokumenta: number = null;
    Datum: Date = null;
    KomitentID: number = null;
    BrojDokumentaKomitenta: string = null;
    DatumDokumentaKomitenta: Date = null;
    BrojOtpremnice: string = null;
    DatumOtpremnice: Date = null;
    RokPlacanja: Date = null;
    Napomena: string = null;
    UticeNaLager:boolean=false;
    
    Deserialize(input: any){
        this.ID = input.ID;
        this.BrojDokumenta = input.BrojDokumenta;
        this.PodVrstaDokumentaStavkaID = input.PodVrstaDokumentaStavkaID;
        this.Datum = input.Datum;
        this.KomitentID = input.KomitentID;
        this.BrojDokumentaKomitenta = input.BrojDokumentaKomitenta;
        this.DatumDokumentaKomitenta = input.DatumDokumentaKomitenta;
        this.BrojOtpremnice = input.BrojOtpremnice;
        this.DatumOtpremnice = input.DatumOtpremnice;
        this.RokPlacanja = input.RokPlacanja;
        this.UticeNaLager=input.UticeNaLager;
        this.Napomena = input.Napomena;
        return this;
    }

    Serialize(input: Dokument){
        return input;
    }

    GetInstance(){
        return this;
    }
}   